"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalBehaviors = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var shared_1 = require("@cian/peperrors/shared");
var constants_1 = require("./internal/constants");
var noopInstance = {
    register: function () { },
    subscribe: function () { },
    unsubscribe: function () { },
    getSubscribers: function () { return []; },
};
function getGlobalBehaviors() {
    if (typeof window === 'undefined') {
        return noopInstance;
    }
    var instance = window[constants_1.STORAGE_GLOBAL_KEY];
    if (!instance) {
        throw new shared_1.ConfigurationError({
            message: 'Необходима предварительная инициализация',
            domain: constants_1.ERRORS_DOMAIN,
        });
    }
    return instance;
}
exports.getGlobalBehaviors = getGlobalBehaviors;
//# sourceMappingURL=interface.js.map